import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPoints } from 'src/app/shared/EndPoints';
import { environment } from 'src/environments/environment';

import { LabOrder } from './../../../../core/classes/create-order';
import { HttpService } from './../../../../core/services/http/http.service';
import { CancelPackageDto, SendPackageDto,CanPlaceUserPrePrintedOrderRequest, CancelOrderDto } from 'src/app/core/classes/package';
import { LabportTestCode } from 'src/app/core/classes/testDto';

@Injectable({
  providedIn: 'root'
})
export class ManagePackageService {
  isHalfWidthSideNav = false;
  CPPortalBaseUrl: any;
  public orderDetails: any;
  constructor(private httpService: HttpService) {
    this.CPPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  public getOrderForm() {
    return this.httpService.Get('assets/stub/order-form.json');
  }

  public getPackageManifestDetails(labPortPackageCode: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getPackageManifestDetails + labPortPackageCode);
  }

  public getAccountPrefDetailsForOrderForm(request: any) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.GetAccountPrefDetailsForOrderForm, request);
  }

  public createPackageOrder(request: LabOrder) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.CreateLabOrder, request);
  }

  public getPrintLabels(data): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.GET_PRINT_LABELS, data);
  }

  public getPackageGridDtos(request: any) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.GetPackageGridDtos, request);
  }

  public getPackageGridOrders(labPortPackageCode: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GetPackageGridOrders + labPortPackageCode);
  }

  public cancelPackage(request: CancelPackageDto) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.CancelPackage, request);
  }

  public cancelOrder(request: CancelOrderDto) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.CancelOrder, JSON.stringify(request));
  }

  public getRequistionManifestDetails(requisitionNumber: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.RequistionManifestDetails + requisitionNumber);
  }

  public sendPackage(request: SendPackageDto) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.SendPackage, request);
  }

  public getShipperTypesByPackageAccount(accountCode: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getShipperTypesByPackageAccount + accountCode);
  }

  public getReceivingLabsByLoggedInCustomerUser() {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getReceivingLabsByLoggedInCustomerUser);
  }

  public getReceivingLabsByLoggedInInternalUser() {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getReceivingLabsByLoggedInInternalUser);
  }

  public getPackageRequisitionNumberSearch(request: any) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.getPackageIdOrRequisitionNumberSearch, request);
  }

  public packageManifestExport(data): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.packageManifestExport, data);
  }
  public requisitionManifestExport(data): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.requisitionManifestExport, data);
  }

  public checkIfReqNoBelongsToLabelrangeByAccCode(accCode: string, reqNo: string) : Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.checkIfReqNoBelongsToLabelRangeByAccCode + accCode + '/' + reqNo);
  }

  public printAllOrderSpecimens(data): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.printAllOrderSpecimens + data);
  }

  public checkAccountCanPlaceUsePrintedLabelsOrder(request: CanPlaceUserPrePrintedOrderRequest) {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.canAccountPlaceUserPrintedLabelOrder, request);
  }

}
